import React from 'react';
import CartItem from './CartItem.jsx';
import ProductCard from './ProductCard.jsx';
import './ShoppingCart.css';
import { useCart } from '../context/CartContext.jsx';
import { useAuth } from '../context/AuthContext.jsx'; // Importamos Auth

const ShoppingCart = () => {
  const { cartItems, subtotal, removeFromCart, loadingCart } = useCart();
  const { user } = useAuth(); // Obtenemos al usuario

  // (En el futuro, relatedProducts vendría de una API)
  const relatedProducts = []; 

  // Manejo de estados de carga y autenticación
  if (!user) {
    return <div className="cart-page-container"><p>Por favor, inicia sesión para ver tu carrito.</p></div>;
  }

  if (loadingCart) {
    return <div className="cart-page-container"><p>Cargando tu carrito...</p></div>;
  }

  return (
    <div className="cart-page-container">
      <div className="cart-layout">
        <div className="cart-main">
          <h2 className="cart-title">Carrito de compras</h2>
          
          <div className="cart-items-list">
            {cartItems.length === 0 ? (
              <p>Tu carrito de compras está vacío.</p>
            ) : (
              cartItems.map(item => (
                <CartItem 
                  key={item.id_product} 
                  item={item}
                  onRemove={() => removeFromCart(item.id_product)} 
                />
              ))
            )}
          </div>
          
          <div className="promo-banner">
            <h3>AHORRA 10% EN TU PRIMERA COMPRA</h3>
            <p>Registra tu cuenta para obtener un cupón de 10% de descuento (Hasta 20.000 pesos descontados).</p>
            <div className="promo-actions">
              <button className="promo-btn-alt">Registrar Mail</button>
              <button className="promo-btn-alt">Registrar ubicacion</button>
            </div>
          </div>
        </div>

        {/* --- Columna Derecha: Sumario de Compra --- */}
        <div className="cart-sidebar">
          <div className="cart-summary">
            <h3>Sumario de la compra</h3>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>${subtotal.toLocaleString('es-AR')} ARS</span>
            </div>
            <div className="summary-row">
              <span>Costo de transporte</span>
              <span>Definido en el pago</span>
            </div>
            <div className="summary-row">
              <span>Tarifa por uso</span>
              <span>Definido en el pago</span>
            </div>
            <hr className="summary-divider" />
            <div className="summary-row total-row">
              <span>Costo total Estimado</span>
              <span>${subtotal.toLocaleString('es-AR')} ARS</span>
            </div>
            
            <button className="proceed-btn" disabled={cartItems.length === 0}>
              Proceder al pago
            </button>
          </div>
        </div>
      </div>

      {/* --- Sección de Productos Similares --- */}
      <div className="related-products-section">
        <h3>Productos similares</h3>
        <div className="related-products-grid">
          {relatedProducts.map(product => (
            <ProductCard 
              key={product.id_product}
              product={product}
            />
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default ShoppingCart;